export default {
  twilioToken: state => state.twilioToken
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/app/getters.js